import React from "react";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";

const Alert = ({ alerts }) =>
  alerts !== null &&
  alerts.length > 0 &&
  alerts.map((alert) => (
    <SweetAlert
      key={alert.id}
      type={alert.alertType}
      title={alert.msg}
      onConfirm={() => console.log("done")}
      showConfirm={false}
      showCancel
      cancelBtnBsStyle={alert.alertType}
      closeOnClickOutside={true}
      cancelBtnText={"Ok"}
    />
  ));

const mapStateToProps = (state) => ({
  alerts: state.alert,
});

export default connect(mapStateToProps)(Alert);
